import React, { createContext, useContext, useState } from "react";

const ChecklistContext = createContext();

const ChecklistProvider = ({ children }) => {
    const [IDCheck, setIDCheck] = useState(1);
    const [activeComment, setActiveComment] = useState(1);

    return (
        <ChecklistContext.Provider value={{ activeComment, setActiveComment, IDCheck, setIDCheck }}>
            {children}
        </ChecklistContext.Provider>
    );
};

const useChecklistContext = () => useContext(ChecklistContext);

export { ChecklistProvider, useChecklistContext };